import { useEffect } from 'react';

interface RFImageOverlayProps {
  map: google.maps.Map | null;
  bounds: google.maps.LatLngBoundsLiteral;
  imageUrl: string;
}

export function RFImageOverlay({ map, bounds, imageUrl }: RFImageOverlayProps) {
  useEffect(() => {
    if (!map) return;

    class CustomOverlay extends google.maps.OverlayView {
      private div_: HTMLDivElement | null = null;

      onAdd() {
        this.div_ = document.createElement('div');
        this.div_.style.border = 'none';
        this.div_.style.position = 'absolute';

        const img = document.createElement('img');
        img.src = imageUrl;
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.position = 'absolute';

        this.div_.appendChild(img);
        this.getPanes()?.overlayLayer.appendChild(this.div_);
      }

      draw() {
        if (!this.div_) return;

        const overlayProjection = this.getProjection();
        if (!overlayProjection) return;

        const sw = overlayProjection.fromLatLngToDivPixel(new google.maps.LatLng(bounds.south, bounds.west))!;
        const ne = overlayProjection.fromLatLngToDivPixel(new google.maps.LatLng(bounds.north, bounds.east))!;

        this.div_.style.left = `${sw.x}px`;
        this.div_.style.top = `${ne.y}px`;
        this.div_.style.width = `${ne.x - sw.x}px`;
        this.div_.style.height = `${sw.y - ne.y}px`;
      }

      onRemove() {
        if (this.div_) {
          this.div_.parentNode?.removeChild(this.div_);
          this.div_ = null;
        }
      }
    }

    const overlay = new CustomOverlay();
    overlay.setMap(map);

    return () => {
      overlay.setMap(null); // Cleanup
    };
  }, [map, bounds, imageUrl]);

  return null;
}
